import React, { createContext, useContext, useEffect, useReducer, ReactNode } from 'react';
import { FeatureUsageContext } from './featureUsageContext';

interface State {
    show: boolean;
    reason: string | null;
}

type Action = { type: 'SHOW_BANNER'; payload: string | null } | { type: 'HIDE_BANNER' };

const initialState: State = {
    show: false,
    reason: null,
};

const SuspensionBannerContext = createContext<{
    state: State;
    dispatch: React.Dispatch<Action>;
}>({
    state: initialState,
    dispatch: () => {
        // do nothing
    },
});

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'SHOW_BANNER':
            return { show: true, reason: action.payload };
        case 'HIDE_BANNER':
            return { show: false, reason: null };
        default:
            return state;
    }
};

export const SuspensionBannerProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const { clientPlan } = useContext(FeatureUsageContext);

    useEffect(() => {
        const dismissed = localStorage.getItem('show_suspension_banner') === 'false';

        if (dismissed) {
            dispatch({ type: 'HIDE_BANNER' });
            return;
        }

        if (clientPlan?.status === 'UPCOMING_SUSPENSION') {
            dispatch({ type: 'SHOW_BANNER', payload: clientPlan.note });
        }
    }, [clientPlan?.status, clientPlan?.note]);

    return (
        <SuspensionBannerContext.Provider value={{ state, dispatch }}>
            {children}
        </SuspensionBannerContext.Provider>
    );
};

export const useSuspensionBanner = () => useContext(SuspensionBannerContext);
